﻿import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';


@Injectable()
export class AuthenticationService {
    constructor(private http: HttpClient) { }

    login(username: string, password: string) {

        return this.http.post<any>(`${environment.apiUrl}/users/authenticate`, { username: username, password: password })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response

                if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                }

                return user;
            }));
    }

    login_token(access_token: string) {

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'

            })
        };

        return this.http.post<any>(`${environment.phpApiUrl}/user/authenticate`, 'jwt_token=' + access_token, httpOptions)
            .pipe(map(user => {
                if (user.message == 'Access granted') {
                    const body = {
                        id: parseInt(user.data.data.id),
                        username: user.data.data.username,
                        drafters_id: user.data.data.drafters_id,
                        firstName: user.data.data.email,
                        token: user.jwt
                    };
                    localStorage.setItem('currentUser', JSON.stringify(body));
                }

                return user;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.clear();
    }
}
